import { useState } from "react";
import { useFieldDrilldown } from "../hooks/useOcrHealthData";
import { SOURCE_COLORS, SOURCE_ORDER } from "../sourceColors";
import styles from "../ocr-health.module.css";
import { PanelCard, PanelError, PanelStatus } from "./PanelCard";

export function PerFieldDrilldownTable() {
  const [jobTypeId, setJobTypeId] = useState<string | undefined>(undefined);
  const { data, isLoading, error } = useFieldDrilldown(jobTypeId);

  return (
    <PanelCard title="Per-Field Drill-down">
      <div className={styles.tableFilter}>
        <span className={styles.statLabel}>Filter</span>
        <input
          type="text"
          className={styles.filterInput}
          placeholder="jobTypeId (optional)"
          value={jobTypeId ?? ""}
          onChange={(e) => setJobTypeId(e.target.value || undefined)}
        />
      </div>
      {isLoading && <PanelStatus>Loading…</PanelStatus>}
      {error && <PanelError>Couldn't load — {error}</PanelError>}
      {data && data.rows.length === 0 && <PanelStatus>No verified data</PanelStatus>}
      {data && data.rows.length > 0 && (
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Field</th>
              {SOURCE_ORDER.map((s) => (
                <th key={s} style={{ color: SOURCE_COLORS[s] }}>
                  {s}
                </th>
              ))}
              <th>Last correction</th>
            </tr>
          </thead>
          <tbody>
            {data.rows.map((row) => (
              <tr key={row.fieldDefinitionId}>
                <td>{row.fieldName}</td>
                {SOURCE_ORDER.map((s) => {
                  const cell = row.perSource[s];
                  return (
                    <td key={s}>
                      {cell ? `${(cell.accuracy * 100).toFixed(0)}% (${cell.total})` : "—"}
                    </td>
                  );
                })}
                <td>
                  {row.lastCorrectionAt
                    ? new Date(row.lastCorrectionAt).toLocaleDateString()
                    : "—"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </PanelCard>
  );
}
